exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-146b4e2a]{height:200px;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-146b4e2a","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/dialysisSummary.vue
// module id = bEPh
// module chunks = 0